import { t } from "@lingui/macro";

import { Button } from "@whoosh/design-system/src/components/controls";
import { BlockIcon } from "@whoosh/design-system/src/components/icons_v2/general";
import {
  VStack,
  Text,
  HStack,
} from "@whoosh/design-system/src/components/primitive";

type CourseColumnsEmptyStateProps = {
  venueLabel: string;
  onPress: () => void;
};

export const CourseColumnsEmptyState = ({
  venueLabel,
  onPress,
}: CourseColumnsEmptyStateProps) => {
  return (
    <HStack
      justifyContent="center"
      alignItems={{ base: "flex-start", lg: "center" }}
      flex={1}
      flexBasis="100%"
      testID="outer-hstack"
      mt={{ base: 12, lg: 0 }}
    >
      <VStack
        py={14}
        px={{ base: 10, lg: 23 }}
        gap={10}
        alignItems={"center"}
        backgroundColor={"surface-secondary"}
        borderRadius="6"
      >
        <VStack gap={4} alignItems={"center"}>
          <BlockIcon color="grayscale.700" />
          <Text
            maxFontSizeMultiplier={2}
            variant="mainBaseMedium"
            textAlign="center"
          >{`${t`No`} ${
            venueLabel ?? t`courses`
          } ${t`found for your filters.`}`}</Text>
        </VStack>
        <Button
          size="regular"
          variant="main"
          onPress={onPress}
          accessibilityLabel={t`Reset Filters button`}
        >
          {t`Reset Filters`}
        </Button>
      </VStack>
    </HStack>
  );
};
